import { render } from "./OurProviders.vue?vue&type=template&id=3979810a&scoped=true"
import script from "./OurProviders.vue?vue&type=script&lang=js"
export * from "./OurProviders.vue?vue&type=script&lang=js"

import "./OurProviders.vue?vue&type=style&index=0&id=3979810a&scoped=true&lang=css"
import "./OurProviders.vue?vue&type=style&index=1&id=3979810a&lang=scss&scoped=true"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3979810a"]])

export default __exports__